import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Rates from "@/components/Rates";
import Billing from "@/components/Billing";
import Reviews from "@/components/Reviews";
import Journal from "@/components/Journal";
import Faq from "@/components/Faq";
import Location from "@/components/Location";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Article from "@/pages/Article";

function Home() {
  return (
    <div className="bg-bone font-sans text-forest antialiased">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Services />
        <Rates />
        <Billing />
        <Reviews />
        <Journal />
        <Faq />
        <Location />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.4 }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/journal/:slug" element={<Article />} />
        </Routes>
      </BrowserRouter>
    </ReactLenis>
  );
}
